import React, { useState } from "react";
import {
  Container,
  Typography,
  TextField,
  MenuItem,
  Button,
  Box,
  Paper,
  IconButton,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { handleSpringDataMutationRequest } from "../../../../api";
import { toast } from "material-react-toastify";
import { useEffect } from "react";

const SettleDues = ({ setOpenDrawer, invoiceData }) => {
  const paymentOptions = [
    "CASH",
    "OFFLINE_CARD",
    "OFFLINE_CHECK",
    "UPI",
    "OTHER_PAYMENT",
    "BANK_TRANSFER",
  ];
  const [formData, setFormData] = useState({
    paymentType: "UPI",
    remarks: "",
    amount: invoiceData?.nrBookingInfo?.balance_due,
  });
  const [submitLoader, setSubmitLoader] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
    setSubmitLoader(true);
    const payload = {
      bookingId: invoiceData?.bookingId,
      hotelId: invoiceData?.nrPackageInfo?.hotel_id,
      paymentType: formData?.paymentType,
      remarks: formData?.remarks,
      amount: +formData?.amount,
    };
    // console.log("Form Submitted:", formData);
    handleSpringDataMutationRequest(
      "POST",
      `core/api/v1/non-rental-booking/settle-dues?bookingId=${invoiceData?.bookingId}`,
      payload
    )
      .then(() => {
        setSubmitLoader(false);
        setOpenDrawer(false);
        toast.success("Payment collected successfully.");
      })
      .catch((err) => {
        toast.error(err?.response.data);
        setSubmitLoader(false);
      });
  };
  useEffect(() => {
    setFormData({
      paymentType: "UPI",
      remarks: "",
      amount: invoiceData?.nrBookingInfo?.balance_due,
    });
  }, [invoiceData]);
  return (
    <Box sx={{ width: 400, p: 2 }}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography sx={{ fontSize: 20, fontWeight: 500 }} gutterBottom>
          Settle Dues
        </Typography>
        <IconButton onClick={() => setOpenDrawer(false)}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box>
        <TextField
          fullWidth
          select
          label="Payment Type"
          name="paymentType"
          value={formData.paymentType}
          onChange={handleChange}
          margin="normal"
        >
          {paymentOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option?.slice(0, 1).toUpperCase() +
                option.slice(1).toLowerCase()?.replace("_", " ")}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          fullWidth
          label="Remarks"
          name="remarks"
          value={formData.remarks}
          onChange={handleChange}
          margin="normal"
          multiline
          rows={3}
        />

        <TextField
          fullWidth
          label="Amount"
          name="amount"
          type="number"
          value={formData.amount}
          onChange={handleChange}
          margin="normal"
          inputProps={{ min: 0, step: 0.01 }}
        />

        <Button
          variant="custom-button"
          fullWidth
          sx={{ mt: 3 }}
          onClick={handleSubmit}
          disabled={submitLoader}
        >
          Submit{" "}
          {submitLoader && <CircularProgress size={15} color="inherit" />}
        </Button>
      </Box>
    </Box>
  );
};

export default SettleDues;
